import {RequestResult, RequestResultValue} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {Game} from "../../models/games";
import {Banner} from "../../models/banner";
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export async function bannersListApi(): Promise<RequestResultValue<Banner[]>> {
    let url = `admin/banners`;
    const response = await HttpService.getInstance().requestGetAsync(url);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<Banner[]>(true, body as Banner[]);
    }
    return new RequestResultValue<Banner[]>(false);
}

export async function deleteBannersApi(id: number): Promise<RequestResult> {
    let url = `admin/banners?id=${id}`;
    const response = await HttpService.getInstance().requestDeleteAsync(url);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function addBannersApi(gameId: number, cellCount: number, canClose: boolean, isActive: boolean, fileRu: File, fileEn: File, fileMobileRu: File, fileMobileEn: File, redirectUrl?: string): Promise<RequestResult> {
    const data = new Map<string, any>();
    data.set('gameId', gameId);
    data.set('cellCount', cellCount);
    data.set('canClose', canClose);
    data.set('isActive', isActive);
    if (redirectUrl) {
        data.set('redirectUrl', redirectUrl);
    }

    const response = await HttpService.getInstance().multipartRequestAsync(
        'admin/banners',
        data,
        "POST",
        [
            {name: 'fileRu', file: fileRu},
            {name: 'fileEn', file: fileEn},
            {name: 'fileMobileRu', file: fileMobileRu},
            {name: 'fileMobileEn', file: fileMobileEn},
        ]
    );
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}


export async function updateBannersApi(id: number, gameId: number, cellCount: number, canClose: boolean, isActive: boolean, fileRu?: File, fileEn?: File, fileMobileRu?: File, fileMobileEn?: File, redirectUrl?: string): Promise<RequestResult> {
    const data = new Map<string, any>();
    data.set('id', id);
    data.set('gameId', gameId);
    data.set('cellCount', cellCount);
    data.set('canClose', canClose);
    data.set('isActive', isActive);
    if (redirectUrl) {
        data.set('redirectUrl', redirectUrl);
    }

    const files:{file:File,name:string}[]=[]
    if(fileRu){
        files.push({name: 'fileRu', file: fileRu})
    }
    if(fileEn){
        files.push({name: 'fileEn', file: fileEn})
    }
    if(fileMobileRu){
        files.push({name: 'fileMobileRu', file: fileMobileRu})
    }
    if(fileMobileEn){
        files.push({name: 'fileMobileEn', file: fileMobileEn})
    }
    const response = await HttpService.getInstance().multipartRequestAsync(
        'admin/banners',
        data,
        "PUT",
        files
    );
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}